import React, { useEffect } from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    var Tawk_API = Tawk_API || {};
    var Tawk_LoadStart = new Date();

    (function () {
      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];

      s1.async = true;
      s1.src = "https://embed.tawk.to/5c29e5b382491369baa000ca/default";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");

      s0.parentNode.insertBefore(s1, s0);
    })();
  }, []);
  const user = localStorage.getItem("user");
  return (
    <footer className="footer-modern">
      <div className="footer-overlay">
        <div className="footer-grid">
          {/* CONTACT */}
          <div className="footer-section">
            <h3 className="footer-heading">Address</h3>

            <p className="footer-address">
              Shop-17, UP GR Floor, Ranuja Complex, Nr- Riddhi Siddhi School,
              Vallabhacharya Road, Ashvani Kumar, Surat-395008 Gujarat, India
            </p>

            <h3 className="footer-heading">Working Hours</h3>
            <div className="business-hours">
              <i className="bi bi-clock-history"></i>
              <span>Mon - Sat: 8:00 AM - 9:00 PM</span>
            </div>
          </div>

          {/* CUSTOMER CARE */}
          <div className="footer-section">
            <h3 className="footer-heading">Customer Care No</h3>

            <a href="tel:+918980995007" className="footer-contact-item">
              <i className="bi bi-telephone-fill"></i>
              +91 89809 95007
            </a>
            <br></br>

            <h3 className="footer-heading">Email</h3>
            <div className="footer-contact-group">
              <a
                href="mailto:lifetime.ltc0777@gmail.com"
                className="footer-contact-item"
              >
                <i className="bi bi-envelope-fill"></i>
                lifetime.ltc0777@gmail.com
              </a>

              <a
                href="mailto:hareshvaddoriya@gmail.com"
                className="footer-contact-item"
              >
                <i className="bi bi-envelope-fill"></i>
                hareshvaddoriya@gmail.com
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>

            <ul className="footer-links">
              <li>
                <a href="/how-to-use">How To Use</a>
              </li>
              <li>
                <a href="/offers">Special Offers</a>
              </li>

              <li>
                <a href="/news">News & Updates</a>
              </li>

              <li>
                <a href="/ads">Ads</a>
              </li>
              <li>
                <a href="/latest-design">Latest Design</a>
              </li>
              <li>
                <a href="/payment-methods">Payment</a>
              </li>
              {user && (
                <li>
                  <a href="/myorders">Design Download</a>
                </li>
              )}

              <li>
                <a href="/contact" target="_blank">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/policy" target="_blank">
                  Terms & Condition
                </a>
              </li>
              <li>
                <a href="/useful-links" target="_blank">
                  Useful Links
                </a>
              </li>
            </ul>
          </div>

          {/* SUPPORT */}
          <div className="footer-section">
            <h3 className="footer-heading">Direct Support</h3>

            <div className="support-card">
              <span>Haresh H. Vaddoriya</span>
              <a href="tel:+919879196990">+91 98791 96990</a>
            </div>

            <div className="support-card">
              <span>Hitesh H. Vaddoriya</span>
              <a href="tel:+919909614445">+91 99096 14445</a>
            </div>
          </div>

          {/* SOCIAL */}
          <div className="footer-section">
            <h3 className="footer-heading">Connect With Us</h3>

            <div className="social-icons">
              <a
                href="https://t.me/EmbroideryDesignLTC"
                target="_blank"
                rel="noreferrer"
                className="social-btn telegram"
              >
                <i className="bi bi-telegram"></i>
              </a>

              <a
                href="https://www.facebook.com/lifetimedesignapps"
                target="_blank"
                rel="noreferrer"
                className="social-btn facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=+919879196990&text=Hello LTC%2C I want to Join Your LTC whatsapp Group to get Daily New Design Updates."
                target="_blank"
                rel="noreferrer"
                className="social-btn whatsapp"
              >
                <i className="bi bi-whatsapp"></i>
              </a>
              <a
                href="https://www.instagram.com/lifetime_embroidery_designclas"
                target="_blank"
                rel="noreferrer"
                className="social-btn instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.youtube.com/@lifetimecreationltc9063"
                target="_blank"
                rel="noreferrer"
                className="social-btn youtube"
              >
                <i className="bi bi-youtube"></i>
              </a>
            </div>

            <br></br>

            <a
              href="https://play.google.com/store/apps/details?id=gnhub.ltc"
              target="_blank"
              rel="noreferrer"
              className="playstore-button"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Google Play"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        <p>© {currentYear} Life Time Designs. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
